import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { AuthGuardService } from './_foundation/services/auth-guard/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/security/login',
    pathMatch: 'full'
  },
  {
    path: 'security',
    loadChildren: 'app/_security/security.module#SecurityModule'
  },
  {
    path: 'vessel-users',
    canActivate: [AuthGuardService],
    loadChildren: 'app/vessel-user/vessel-user.container.module#VesselUserContainerModule'
  },
  {
    path: 'vessel',
    canActivate: [AuthGuardService],
    loadChildren: 'app/vessels/vessels.container.module#VesselsContainerModule'
  },
  {
    path: 'vessel-classes',
    canActivate: [AuthGuardService],
    loadChildren: 'app/vessel-classes/vessel-classes.container.module#VesselClassesContainerModule'
  },
  {
    path: 'vessel-report',
    canActivate: [AuthGuardService],
    loadChildren: 'app/vessel-report/vessel-report.module#VesselReportModule'
  },
  {
    path: 'locations',
    canActivate: [AuthGuardService],
    loadChildren: 'app/locations/locations.container.module#LocationsContainerModule'
  },
  {
    path: 'location-type',
    canActivate: [AuthGuardService],
    loadChildren: 'app/location-type/location-type.container.module#LocationTypeContainerModule'
  },
  {
    path: 'coa',
    canActivate: [AuthGuardService],
    loadChildren: 'app/coas/coa.container.module#CoaContainerModule'
  },
  {
    path: 'operation',
    canActivate: [AuthGuardService],
    loadChildren: 'app/operation/operation.container.module#OperationContainerModule'
  },
  {
    path: 'operation-classification',
    canActivate: [AuthGuardService],
    loadChildren: 'app/operation-classification/operation-classification.container.module#OperationClassificationContainerModule'
  },
  {
    path: 'project-types',
    canActivate: [AuthGuardService],
    loadChildren: 'app/project-types/project-types.container.module#ProjectTypesContainerModule'
  },
  {
    path: 'projects',
    canActivate: [AuthGuardService],
    loadChildren: 'app/projects/projects.container.module#ProjectsContainerModule'
  },
  {
    path: 'backoffice/replication/log',
    canActivate: [AuthGuardService],
    loadChildren:
      'app/infrastructure/backoffice-replication-log/backoffice-replication-log.container.module#BackofficeReplicationLogContainerModule'
  },
  {
    path: 'releases',
    canActivate: [AuthGuardService],
    loadChildren: 'app/infrastructure/releases/releases.container.module#ReleasesContainerModule'
  },
  {
    path: 'change-audit',
    canActivate: [AuthGuardService],
    loadChildren: 'app/change-audit/change-audit.container.module#ChangeAuditContainerModule'
  },
  {
    path: '**',
    redirectTo: '/vessel-report/grid',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

